import { createUseStyles } from 'react-jss'
import { backgroundGrey, darkGrey, lightGrey, mediumGrey } from '../../../styles/const/colors'
import { lineHeight } from '../../../styles/typography'

// import { tabletDown } from '../../theme/breakpoints'
// import { containerPadding } from '../../theme/common'

const useStyles = createUseStyles({
  option: {
    borderBottom: ({ withUnderline }) => (withUnderline ? `1px solid ${lightGrey}` : 'none')
  },
  optionInnerContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  disabled: {
    color: [darkGrey, '!important'],
    backgroundColor: backgroundGrey,
    cursor: ['not-allowed', '!important']
  },
  pseudoDisabled: {
    composes: '$disabled'
  },
  iconContainer: {
    display: 'flex',
    marginRight: 10,
    minWidth: 22,
    maxWidth: 22,
    height: 22,

    '& svg, & img': {
      width: '100%',
      maxWidth: '100%',
      objectFit: 'contain'
    }
  },
  label: {
    fontSize: 14,
    lineHeight: lineHeight,
    /* 1) allow normal wrapping at spaces */
    whiteSpace: 'normal',
    /* 2) avoid breaking inside “real” words (i.e. only break at spaces/underscores) */
    wordsBreak: 'keep-all',
    /* 3) if a single token is longer than its container
     e.g. 'Eukanuba_Crufts_Partner_Partner'
     break it anywhere
     so it doesn’t overflow or get clipped */
    overflowWrap: 'anywhere',
    /* legacy fallback for older browsers */
    wordWrap: 'break-word'
  },
  description: {
    color: mediumGrey,
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: '400'
  },
  tag: {
    composes: 'tag',
    marginLeft: 'auto !important'
  },
  chip: {
    marginLeft: 'auto !important'
  }
})

export default useStyles
